import React from 'react';

interface SectionHeaderProps {
  title: string;
  icon: React.ReactNode;
  iconBgColor?: string;
  iconTextColor?: string;
  titleColor?: string;
  children?: React.ReactNode;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  icon,
  iconBgColor = 'bg-blue-100',
  iconTextColor = 'text-blue-600',
  titleColor = 'text-blue-600',
  children,
  className,
}) => {
  return (
    <div className={`bg-white border border-slate-200 rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-200 ${className || ''}`}>
      <div className="flex items-center gap-3 mb-6">
        <div className={`w-10 h-10 ${iconBgColor} rounded-lg flex items-center justify-center`}>
          <div className={`w-6 h-6 ${iconTextColor}`}>
            {icon}
          </div>
        </div>
        <h3 className={`text-2xl font-semibold ${titleColor}`}>{title}</h3>
      </div>
      <div className="space-y-6">
        {children}
      </div>
    </div>
  );
};

export default SectionHeader;
